var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect, _g2, _path30, _g3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g4, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g5, _path56, _rect2, _rect3, _g6, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g7, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g8, _path90, _g9, _g10, _g11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecoverRecycleBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 578,
    viewBox: "0 0 605 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.136 452.976C135.117 448.593 62.4467 463.106 90.7722 473.069C119.098 483.023 39.4714 482.469 45.1166 494.08C48.8772 501.818 68.8173 511.001 104.43 506.555C140.043 502.109 165.721 518.371 131.59 529.239C97.4587 540.107 185.875 560.599 247.373 537.43C308.88 514.252 348.008 505.56 393.868 507.928C439.728 510.297 540.538 501.85 517.568 477.809C499.129 458.507 457.625 459.169 421.755 456.436C385.895 453.694 208.136 452.976 208.136 452.976Z",
    fill: "#EFF0F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M172.54 81.9999C169.96 81.9999 167.86 79.8999 167.86 77.3199H170.55C170.55 78.4199 171.44 79.3099 172.54 79.3099C173.64 79.3099 174.53 78.4199 174.53 77.3199C174.53 76.2199 173.64 75.3299 172.54 75.3299V72.6399C175.12 72.6399 177.22 74.7399 177.22 77.3199C177.23 79.8999 175.12 81.9999 172.54 81.9999Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.11 143.6C249.53 143.6 247.43 141.5 247.43 138.92H250.12C250.12 140.02 251.01 140.91 252.11 140.91C253.21 140.91 254.1 140.02 254.1 138.92C254.1 137.82 253.21 136.93 252.11 136.93V134.24C254.69 134.24 256.79 136.34 256.79 138.92C256.8 141.5 254.7 143.6 252.11 143.6Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.8001 268.15C97.2201 268.15 95.1201 266.05 95.1201 263.47H97.8101C97.8101 264.57 98.7001 265.46 99.8001 265.46C100.9 265.46 101.79 264.57 101.79 263.47C101.79 262.37 100.9 261.48 99.8001 261.48V258.79C102.38 258.79 104.48 260.89 104.48 263.47C104.49 266.05 102.38 268.15 99.8001 268.15Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M225.55 348.86C222.97 348.86 220.87 346.76 220.87 344.18H223.56C223.56 345.28 224.45 346.17 225.55 346.17C226.65 346.17 227.54 345.28 227.54 344.18C227.54 343.08 226.65 342.19 225.55 342.19V339.5C228.13 339.5 230.23 341.6 230.23 344.18C230.24 346.76 228.14 348.86 225.55 348.86Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M264.13 245.64C261.55 245.64 259.45 243.54 259.45 240.96H262.14C262.14 242.06 263.03 242.95 264.13 242.95C265.23 242.95 266.12 242.06 266.12 240.96C266.12 239.86 265.23 238.97 264.13 238.97V236.28C266.71 236.28 268.81 238.38 268.81 240.96C268.81 243.54 266.71 245.64 264.13 245.64Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.02 199.25C174.44 199.25 172.34 197.15 172.34 194.57H175.03C175.03 195.67 175.92 196.56 177.02 196.56C178.12 196.56 179.01 195.67 179.01 194.57C179.01 193.47 178.12 192.58 177.02 192.58V189.89C179.6 189.89 181.7 191.99 181.7 194.57C181.7 197.15 179.6 199.25 177.02 199.25Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M188.81 251.81C186.23 251.81 184.13 249.71 184.13 247.13H186.82C186.82 248.23 187.71 249.12 188.81 249.12C189.91 249.12 190.8 248.23 190.8 247.13C190.8 246.03 189.91 245.14 188.81 245.14V242.45C191.39 242.45 193.49 244.55 193.49 247.13C193.49 249.7 191.39 251.81 188.81 251.81Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M367.21 161.58C364.63 161.58 362.53 159.48 362.53 156.9H365.22C365.22 158 366.11 158.89 367.21 158.89C368.31 158.89 369.2 158 369.2 156.9C369.2 155.8 368.31 154.91 367.21 154.91V152.22C369.79 152.22 371.89 154.32 371.89 156.9C371.89 159.47 369.79 161.58 367.21 161.58Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.77 187.53C251.19 187.53 249.09 185.43 249.09 182.85H251.78C251.78 183.95 252.67 184.84 253.77 184.84C254.87 184.84 255.76 183.95 255.76 182.85C255.76 181.75 254.87 180.86 253.77 180.86V178.17C256.35 178.17 258.45 180.27 258.45 182.85C258.46 185.43 256.35 187.53 253.77 187.53Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.77 242.24C344.19 242.24 342.09 240.14 342.09 237.56H344.78C344.78 238.66 345.67 239.55 346.77 239.55C347.87 239.55 348.76 238.66 348.76 237.56C348.76 236.46 347.87 235.57 346.77 235.57V232.88C349.35 232.88 351.45 234.98 351.45 237.56C351.45 240.14 349.35 242.24 346.77 242.24Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M438.8 302.76C436.22 302.76 434.12 300.66 434.12 298.08H436.81C436.81 299.18 437.7 300.07 438.8 300.07C439.9 300.07 440.79 299.18 440.79 298.08C440.79 296.98 439.9 296.09 438.8 296.09V293.4C441.38 293.4 443.48 295.5 443.48 298.08C443.48 300.66 441.38 302.76 438.8 302.76Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M495.01 329.13C492.43 329.13 490.33 327.03 490.33 324.45H493.02C493.02 325.55 493.91 326.44 495.01 326.44C496.11 326.44 497 325.55 497 324.45C497 323.35 496.11 322.46 495.01 322.46V319.77C497.59 319.77 499.69 321.87 499.69 324.45C499.69 327.03 497.59 329.13 495.01 329.13Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M457.201 375.27C454.621 375.27 452.521 373.17 452.521 370.59H455.211C455.211 371.69 456.101 372.58 457.201 372.58C458.301 372.58 459.191 371.69 459.191 370.59C459.191 369.49 458.301 368.6 457.201 368.6V365.91C459.781 365.91 461.881 368.01 461.881 370.59C461.881 373.17 459.781 375.27 457.201 375.27Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.23 316.21C351.65 316.21 349.55 314.11 349.55 311.53H352.24C352.24 312.63 353.13 313.52 354.23 313.52C355.33 313.52 356.22 312.63 356.22 311.53C356.22 310.43 355.33 309.54 354.23 309.54V306.85C356.81 306.85 358.91 308.95 358.91 311.53C358.91 314.11 356.81 316.21 354.23 316.21Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M324.14 193.5C321.56 193.5 319.46 191.4 319.46 188.82H322.15C322.15 189.92 323.04 190.81 324.14 190.81C325.24 190.81 326.13 189.92 326.13 188.82C326.13 187.72 325.24 186.83 324.14 186.83V184.14C326.72 184.14 328.82 186.24 328.82 188.82C328.82 191.4 326.72 193.5 324.14 193.5Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M176.26 123.71C173.68 123.71 171.58 121.61 171.58 119.03H174.27C174.27 120.13 175.16 121.02 176.26 121.02C177.36 121.02 178.25 120.13 178.25 119.03C178.25 117.93 177.36 117.04 176.26 117.04V114.35C178.84 114.35 180.94 116.45 180.94 119.03C180.94 121.61 178.84 123.71 176.26 123.71Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M225.84 89.6598C223.26 89.6598 221.16 87.5598 221.16 84.9798H223.85C223.85 86.0798 224.74 86.9698 225.84 86.9698C226.94 86.9698 227.83 86.0798 227.83 84.9798C227.83 83.8798 226.94 82.9898 225.84 82.9898V80.2998C228.42 80.2998 230.52 82.3998 230.52 84.9798C230.53 87.5598 228.43 89.6598 225.84 89.6598Z",
    fill: "#F9C6B5"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.76 295.32C163.18 295.32 161.08 293.22 161.08 290.64H163.77C163.77 291.74 164.66 292.63 165.76 292.63C166.86 292.63 167.75 291.74 167.75 290.64C167.75 289.54 166.86 288.65 165.76 288.65V285.96C168.34 285.96 170.44 288.06 170.44 290.64C170.44 293.22 168.34 295.32 165.76 295.32Z",
    fill: "#F9C6B5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M239.89 386.59C237.31 386.59 235.21 384.49 235.21 381.91C235.21 379.33 237.31 377.23 239.89 377.23C242.47 377.23 244.57 379.33 244.57 381.91H241.88C241.88 380.81 240.99 379.92 239.89 379.92C238.79 379.92 237.9 380.81 237.9 381.91C237.9 383.01 238.79 383.9 239.89 383.9V386.59Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.191 320.15C244.611 320.15 242.511 318.05 242.511 315.47C242.511 312.89 244.611 310.79 247.191 310.79C249.771 310.79 251.871 312.89 251.871 315.47H249.181C249.181 314.37 248.291 313.48 247.191 313.48C246.091 313.48 245.201 314.37 245.201 315.47C245.201 316.57 246.091 317.46 247.191 317.46V320.15Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.151 315.04C179.571 315.04 177.471 312.94 177.471 310.36C177.471 307.78 179.571 305.68 182.151 305.68C184.731 305.68 186.831 307.78 186.831 310.36H184.141C184.141 309.26 183.251 308.37 182.151 308.37C181.051 308.37 180.161 309.26 180.161 310.36C180.161 311.46 181.051 312.35 182.151 312.35V315.04Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M237.321 269.97C234.741 269.97 232.641 267.87 232.641 265.29C232.641 262.71 234.741 260.61 237.321 260.61C239.901 260.61 242.001 262.71 242.001 265.29H239.311C239.311 264.19 238.421 263.3 237.321 263.3C236.221 263.3 235.331 264.19 235.331 265.29C235.331 266.39 236.221 267.28 237.321 267.28V269.97Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M236.201 222.01C233.621 222.01 231.521 219.91 231.521 217.33C231.521 214.75 233.621 212.65 236.201 212.65C238.781 212.65 240.881 214.75 240.881 217.33H238.191C238.191 216.23 237.301 215.34 236.201 215.34C235.101 215.34 234.211 216.23 234.211 217.33C234.211 218.43 235.101 219.32 236.201 219.32V222.01Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128.22 284.39C125.64 284.39 123.54 282.29 123.54 279.71C123.54 277.13 125.64 275.03 128.22 275.03C130.8 275.03 132.9 277.13 132.9 279.71H130.21C130.21 278.61 129.32 277.72 128.22 277.72C127.12 277.72 126.23 278.61 126.23 279.71C126.23 280.81 127.12 281.7 128.22 281.7V284.39Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.0003 231.24C87.4203 231.24 85.3203 229.14 85.3203 226.56C85.3203 223.98 87.4203 221.88 90.0003 221.88C92.5803 221.88 94.6803 223.98 94.6803 226.56H91.9903C91.9903 225.46 91.1003 224.57 90.0003 224.57C88.9003 224.57 88.0103 225.46 88.0103 226.56C88.0103 227.66 88.9003 228.55 90.0003 228.55V231.24Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M216.611 177.24C214.031 177.24 211.931 175.14 211.931 172.56C211.931 169.98 214.031 167.88 216.611 167.88C219.191 167.88 221.291 169.98 221.291 172.56H218.601C218.601 171.46 217.711 170.57 216.611 170.57C215.511 170.57 214.621 171.46 214.621 172.56C214.621 173.66 215.511 174.55 216.611 174.55V177.24Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.58 120.74C210 120.74 207.9 118.64 207.9 116.06C207.9 113.48 210 111.38 212.58 111.38C215.16 111.38 217.26 113.48 217.26 116.06H214.57C214.57 114.96 213.68 114.07 212.58 114.07C211.48 114.07 210.59 114.96 210.59 116.06C210.59 117.16 211.48 118.05 212.58 118.05V120.74Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M200.441 84.9799C197.861 84.9799 195.761 82.8799 195.761 80.2999C195.761 77.7199 197.861 75.6199 200.441 75.6199C203.021 75.6199 205.121 77.7199 205.121 80.2999H202.431C202.431 79.1999 201.541 78.3099 200.441 78.3099C199.341 78.3099 198.451 79.1999 198.451 80.2999C198.451 81.3999 199.341 82.2899 200.441 82.2899V84.9799Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M184.52 58.7899C181.94 58.7899 179.84 56.6899 179.84 54.1099C179.84 51.5299 181.94 49.4299 184.52 49.4299C187.1 49.4299 189.2 51.5299 189.2 54.1099H186.51C186.51 53.0099 185.62 52.1199 184.52 52.1199C183.42 52.1199 182.53 53.0099 182.53 54.1099C182.53 55.2099 183.42 56.0999 184.52 56.0999V58.7899Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133.941 69.7099C131.361 69.7099 129.261 67.6099 129.261 65.0299C129.261 62.4499 131.361 60.3499 133.941 60.3499C136.521 60.3499 138.621 62.4499 138.621 65.0299H135.931C135.931 63.9299 135.041 63.0399 133.941 63.0399C132.841 63.0399 131.951 63.9299 131.951 65.0299C131.951 66.1299 132.841 67.0199 133.941 67.0199V69.7099Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M309.35 133.22C306.77 133.22 304.67 131.12 304.67 128.54C304.67 125.96 306.77 123.86 309.35 123.86C311.93 123.86 314.03 125.96 314.03 128.54H311.34C311.34 127.44 310.45 126.55 309.35 126.55C308.25 126.55 307.36 127.44 307.36 128.54C307.36 129.64 308.25 130.53 309.35 130.53V133.22Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M287 171.71C284.42 171.71 282.32 169.61 282.32 167.03C282.32 164.45 284.42 162.35 287 162.35C289.58 162.35 291.68 164.45 291.68 167.03H288.99C288.99 165.93 288.1 165.04 287 165.04C285.9 165.04 285.01 165.93 285.01 167.03C285.01 168.13 285.9 169.02 287 169.02V171.71Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M308.47 211.78C305.89 211.78 303.79 209.68 303.79 207.1C303.79 204.52 305.89 202.42 308.47 202.42C311.05 202.42 313.15 204.52 313.15 207.1H310.46C310.46 206 309.57 205.11 308.47 205.11C307.37 205.11 306.48 206 306.48 207.1C306.48 208.2 307.37 209.09 308.47 209.09V211.78Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.16 194.88C390.58 194.88 388.48 192.78 388.48 190.2C388.48 187.62 390.58 185.52 393.16 185.52C395.74 185.52 397.84 187.62 397.84 190.2H395.15C395.15 189.1 394.26 188.21 393.16 188.21C392.06 188.21 391.17 189.1 391.17 190.2C391.17 191.3 392.06 192.19 393.16 192.19V194.88Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M368.191 125.33C365.611 125.33 363.511 123.23 363.511 120.65C363.511 118.07 365.611 115.97 368.191 115.97C370.771 115.97 372.871 118.07 372.871 120.65H370.181C370.181 119.55 369.291 118.66 368.191 118.66C367.091 118.66 366.201 119.55 366.201 120.65C366.201 121.75 367.091 122.64 368.191 122.64V125.33Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M408.93 141.08C406.35 141.08 404.25 138.98 404.25 136.4C404.25 133.82 406.35 131.72 408.93 131.72C411.51 131.72 413.61 133.82 413.61 136.4H410.92C410.92 135.3 410.03 134.41 408.93 134.41C407.83 134.41 406.94 135.3 406.94 136.4C406.94 137.5 407.83 138.39 408.93 138.39V141.08Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M377.05 278.37C374.47 278.37 372.37 276.27 372.37 273.69C372.37 271.11 374.47 269.01 377.05 269.01C379.63 269.01 381.73 271.11 381.73 273.69H379.04C379.04 272.59 378.15 271.7 377.05 271.7C375.95 271.7 375.06 272.59 375.06 273.69C375.06 274.79 375.95 275.68 377.05 275.68V278.37Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M470.231 305.72C467.651 305.72 465.551 303.62 465.551 301.04C465.551 298.46 467.651 296.36 470.231 296.36C472.811 296.36 474.911 298.46 474.911 301.04H472.221C472.221 299.94 471.331 299.05 470.231 299.05C469.131 299.05 468.241 299.94 468.241 301.04C468.241 302.14 469.131 303.03 470.231 303.03V305.72Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M431.59 346.69C429.01 346.69 426.91 344.59 426.91 342.01C426.91 339.43 429.01 337.33 431.59 337.33C434.17 337.33 436.27 339.43 436.27 342.01H433.58C433.58 340.91 432.69 340.02 431.59 340.02C430.49 340.02 429.6 340.91 429.6 342.01C429.6 343.11 430.49 344 431.59 344V346.69Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M488.691 367C486.111 367 484.011 364.9 484.011 362.32C484.011 359.74 486.111 357.64 488.691 357.64C491.271 357.64 493.371 359.74 493.371 362.32H490.681C490.681 361.22 489.791 360.33 488.691 360.33C487.591 360.33 486.701 361.22 486.701 362.32C486.701 363.42 487.591 364.31 488.691 364.31V367Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M528.191 335.97C525.611 335.97 523.511 333.87 523.511 331.29C523.511 328.71 525.611 326.61 528.191 326.61C530.771 326.61 532.871 328.71 532.871 331.29H530.181C530.181 330.19 529.291 329.3 528.191 329.3C527.091 329.3 526.201 330.19 526.201 331.29C526.201 332.39 527.091 333.28 528.191 333.28V335.97Z",
    fill: "#B5EFF9"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 400.68C185.31 392.6 171.13 383.2 175.13 365.61C179.13 348.03 177.33 347.39 162.63 336.05C147.92 324.71 156.95 319.32 157.64 308.16C158.33 297 147.12 291.47 137.99 280.86C128.85 270.24 140.4 245.73 156.12 252.1C171.84 258.48 159.39 275.58 172.3 286.27C185.21 296.97 209.2 290.84 208.72 306.38C208.24 321.92 191.78 336.07 208.06 344.42C224.34 352.77 235.39 358.75 229.41 376.89C223.43 395.04 212.3 400.68 212.3 400.68Z",
    fill: "#DDF7FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.53 278.34C169.35 306.16 183.07 334.03 196.69 361.94C203.53 375.88 210.59 389.72 216.99 403.87C223.3 418.06 229.68 432.22 235.28 446.76L234.91 446.93C227.22 433.39 220.31 419.48 213.33 405.6C206.44 391.68 200.21 377.45 193.76 363.32C180.79 335.1 167.93 306.82 155.17 278.5L155.53 278.34Z",
    fill: "#ABB8FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.61 311.69C184.12 313.79 181.14 315.84 177.69 318.21C172.61 321.71 166.44 325.99 162.9 332.18C160.18 324.84 155.96 317.99 150.17 312.75C149.56 312.18 148.9 311.69 148.28 311.15C147.84 304.63 151.06 298.51 153.92 293.1C155.75 289.64 157.33 286.64 157.69 284.01C157.77 283.44 157.37 282.91 156.8 282.84C156.23 282.76 155.7 283.15 155.63 283.73C155.32 286 153.82 288.84 152.08 292.12C149.5 297 146.38 302.97 146.19 309.36C138.99 303.5 130.97 299 122.57 295.34C122.76 295.04 122.78 294.64 122.58 294.31C119.36 289.09 119.43 282.6 119.5 276.87C119.54 273.24 119.58 270.1 118.76 267.77C118.58 267.27 118.03 267 117.52 267.18C117.02 267.35 116.75 267.9 116.93 268.42C117.63 270.42 117.6 273.4 117.56 276.85C117.5 282.25 117.46 288.88 120.45 294.42C117.02 292.99 113.54 291.68 110.03 290.46C109.84 290.25 109.6 290.1 109.29 290.11C109.21 290.11 109.14 290.13 109.06 290.13C105.53 288.92 102 287.77 98.4696 286.7C101.48 287.9 104.5 289.09 107.5 290.3C101.55 291.11 96.3196 294.65 92.0496 297.57C89.1996 299.52 86.7396 301.2 84.6896 301.73C84.1696 301.86 83.8596 302.39 83.9896 302.91C84.1196 303.43 84.6496 303.74 85.1696 303.61C87.5596 303 90.1496 301.23 93.1496 299.17C97.8796 295.94 103.23 292.27 109.37 292.05C109.76 292.04 110.08 291.8 110.22 291.47C110.23 291.45 110.23 291.42 110.23 291.4C115.26 293.47 120.22 295.65 124.98 298.26C127.01 299.32 129.02 300.43 131 301.59C124.93 302.76 119.63 306.52 115.26 309.63C112.23 311.79 109.61 313.65 107.41 314.26C106.85 314.41 106.52 314.99 106.68 315.54C106.83 316.1 107.41 316.43 107.96 316.27C110.52 315.57 113.28 313.6 116.47 311.33C121.5 307.75 127.2 303.7 133.81 303.34C133.81 303.34 133.84 303.32 133.86 303.32C139.09 306.59 144.01 310.29 148.28 314.65C149.82 316.19 151.24 317.85 152.55 319.57C145.52 321.58 139.85 326.79 135.23 331.07C132.16 333.92 129.51 336.38 127.14 337.37C126.53 337.62 126.26 338.32 126.51 338.91C126.76 339.51 127.45 339.79 128.05 339.54C130.81 338.38 133.6 335.79 136.83 332.79C141.69 328.28 147.18 323.25 154.02 321.61C154.98 323 155.89 324.41 156.73 325.87C159.05 329.95 160.53 334.43 161.71 338.98C162.62 343.04 163.14 347.19 163.52 351.38C158.2 351.02 152.96 352.98 148.63 354.6C145.62 355.73 143.02 356.7 141.04 356.72C140.53 356.72 140.14 357.13 140.14 357.63C140.14 358.13 140.55 358.53 141.05 358.53C143.35 358.51 146.09 357.48 149.26 356.29C153.72 354.62 158.7 352.77 163.7 353.21C164.06 357.93 164.23 362.71 164.45 367.49C164.73 372.71 165.11 377.96 165.72 383.2C162.05 381.71 157.91 381.62 154.46 381.56C151.89 381.52 149.67 381.49 148.19 380.92C147.81 380.78 147.4 380.96 147.26 381.34C147.12 381.71 147.3 382.13 147.68 382.27C149.4 382.93 151.74 382.96 154.45 383C158.2 383.06 162.39 383.13 165.95 384.84C166.45 388.75 167.05 392.64 167.94 396.5C170.09 406.05 173.43 415.38 178.13 423.96C187.4 441.26 201.01 455.63 215.75 468.05C208.94 461.19 202.04 454.41 196.2 446.75C190.18 439.27 184.7 431.32 180.51 422.73C176.3 414.16 173 405.17 171.05 395.83C171.02 395.69 171 395.54 170.97 395.4C171.06 395.35 171.16 395.29 171.22 395.2C173.85 391.45 178.31 389.59 182.26 387.95C184.76 386.91 186.92 386.01 188.27 384.76C188.56 384.49 188.58 384.03 188.31 383.74C188.04 383.45 187.59 383.43 187.29 383.7C186.13 384.77 184.08 385.63 181.7 386.62C178.04 388.15 173.56 390.05 170.64 393.63C168.96 385.01 168.34 376.19 167.95 367.32C167.93 366.91 167.9 366.49 167.88 366.08C172.35 362.96 178.1 362.42 183.21 361.96C186.58 361.66 189.5 361.4 191.58 360.42C192.03 360.21 192.23 359.67 192.01 359.22C191.8 358.77 191.27 358.57 190.81 358.79C189.02 359.63 186.25 359.88 183.05 360.16C178.29 360.59 172.5 361.13 167.77 363.99C167.32 355.45 166.83 346.78 164.82 338.23C164.57 337.23 164.28 336.25 163.98 335.26C166.93 328.48 173.36 324.05 179.05 320.13C182.68 317.63 185.82 315.47 187.55 313.04C187.93 312.51 187.8 311.78 187.27 311.4C186.72 311.04 185.99 311.16 185.61 311.69Z",
    fill: "#E6E9F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.34 286.8C118.04 287.3 117.3 287.29 116.99 286.79C109.77 275.26 114.56 269.26 112.86 262.51C111.36 256.56 118.83 268.45 123.03 270.57C126.55 272.35 120.41 283.31 118.34 286.8Z",
    fill: "#B5EFF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.94 300.81C149.41 301.14 148.7 300.76 148.65 300.14C147.4 285.53 154.96 282.13 156.65 274.83C158.14 268.38 159.45 283.47 162.43 287.57C164.93 291 153.65 298.48 149.94 300.81Z",
    fill: "#B5EFF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.04 325.76C170.34 325.82 169.83 325.07 170.1 324.42C176.47 309.21 185.78 309.76 191.27 303.35C196.12 297.7 189.56 313.42 190.39 319.07C191.09 323.8 175.95 325.37 171.04 325.76Z",
    fill: "#B5EFF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.73 362.71C175.24 362.48 175.18 361.79 175.61 361.46C185.62 353.69 191.64 357.57 197.73 355.36C203.11 353.41 192.78 361.45 191.2 365.55C189.89 368.97 179.16 364.31 175.73 362.71Z",
    fill: "#B5EFF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.72 390.33C176.29 390.27 176.08 389.76 176.33 389.4C182.09 381.06 187.62 382.57 191.74 379.41C195.37 376.63 189.43 385.25 189.22 388.75C189.03 391.7 179.72 390.72 176.72 390.33Z",
    fill: "#B5EFF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8298 294.69C100.08 294.16 99.6598 293.55 99.0698 293.57C85.4798 293.96 83.1398 301.29 76.5798 303.61C70.7898 305.66 84.8398 305.28 88.9298 307.6C92.3698 309.54 98.0698 298.35 99.8298 294.69Z",
    fill: "#B5EFF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.58 306.37C123.84 305.8 123.37 305.15 122.74 305.18C108.1 305.87 105.72 313.8 98.7002 316.44C92.5002 318.77 107.63 318.08 112.09 320.5C115.84 322.52 121.77 310.35 123.58 306.37Z",
    fill: "#B5EFF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.04 326.23C144.25 325.56 143.63 324.9 142.93 325.02C126.7 327.92 125.2 337.12 117.75 341.08C111.18 344.58 127.95 341.61 133.28 343.65C137.75 345.38 142.59 330.94 144.04 326.23Z",
    fill: "#B5EFF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.3 353.74C156.64 353.32 156.4 352.67 155.87 352.56C143.48 349.89 139.74 355.99 133.28 356.64C127.59 357.21 140.38 359.99 143.57 363C146.25 365.51 153.9 356.66 156.3 353.74Z",
    fill: "#B5EFF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.429 383.18C160.809 382.97 160.809 382.41 160.449 382.17C152.009 376.56 147.429 380.01 142.439 378.6C138.029 377.36 146.749 383.17 148.239 386.34C149.499 389.01 157.779 384.66 160.429 383.18Z",
    fill: "#B5EFF9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.13 287.69C103.38 288.16 103.01 288.72 102.49 288.73C90.1899 288.87 87.8099 282.34 81.7999 280.48C76.4999 278.84 89.1999 278.67 92.8199 276.43C95.8499 274.55 101.41 284.45 103.13 287.69Z",
    fill: "#B5EFF9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.491 475.481C175.111 473.821 172.891 468.871 174.551 464.491C176.211 460.111 181.161 457.891 185.541 459.551C189.921 461.211 192.141 466.161 190.481 470.541C188.821 474.921 183.871 477.141 179.491 475.481Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.3367,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189 468.21L189.89 459.1L190.79 450L198.23 455.33L205.66 460.66L197.33 464.43L189 468.21Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.4271,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M135.546 358.926C134.3 360.474 131.922 361.912 129.158 363.583C125.093 366.043 120.158 369.062 117.154 373.67C115.398 367.897 112.45 362.443 108.238 358.151C107.794 357.684 107.304 357.282 106.857 356.836C106.814 351.794 109.568 347.235 112.001 343.207C113.565 340.631 114.914 338.393 115.313 336.384C115.401 335.949 115.117 335.529 114.682 335.441C114.247 335.353 113.827 335.637 113.739 336.072C113.393 337.804 112.114 339.921 110.634 342.372C108.428 346.01 105.76 350.458 105.324 355.371C100.055 350.537 94.0773 346.721 87.7809 343.521C87.9455 343.295 87.98 342.992 87.8341 342.726C85.5856 338.561 85.9421 333.571 86.2489 329.173C86.4437 326.375 86.6202 323.963 86.0898 322.136C85.9833 321.739 85.5571 321.512 85.1683 321.625C84.7713 321.731 84.5421 322.143 84.6569 322.546C85.108 324.115 84.9514 326.408 84.7572 329.061C84.4736 333.209 84.1388 338.311 86.195 342.708C83.6154 341.454 81.0021 340.287 78.3607 339.197C78.2255 339.022 78.043 338.899 77.8045 338.895C77.7462 338.892 77.6907 338.903 77.6325 338.9C74.9772 337.813 72.3023 336.772 69.6383 335.788C71.8998 336.851 74.1725 337.898 76.4258 338.956C71.8119 339.311 67.6301 341.801 64.2129 343.853C61.9384 345.227 59.9642 346.406 58.3626 346.727C57.9518 346.8 57.6921 347.204 57.7709 347.606C57.8496 348.008 58.2396 348.271 58.6421 348.192C60.5102 347.834 62.5789 346.586 64.9757 345.137C68.76 342.862 73.0393 340.281 77.7732 340.393C78.07 340.399 78.3314 340.226 78.4572 339.985C78.4684 339.968 78.4657 339.954 78.4685 339.932C82.2468 341.751 85.9692 343.652 89.51 345.878C91.0206 346.786 92.5227 347.724 93.9913 348.712C89.2653 349.341 85.0218 351.994 81.5236 354.184C79.0987 355.711 76.9992 357.022 75.2697 357.389C74.8339 357.482 74.5575 357.911 74.65 358.346C74.7425 358.782 75.1712 359.059 75.607 358.966C77.6058 358.539 79.8193 357.148 82.3749 355.552C86.4126 353.026 90.9759 350.166 96.0736 350.185C96.0736 350.185 96.1013 350.179 96.1152 350.177C99.9894 352.928 103.61 356.002 106.701 359.54C107.819 360.798 108.829 362.128 109.763 363.516C104.269 364.75 99.6718 368.502 95.923 371.585C93.4349 373.635 91.2891 375.409 89.4225 376.07C88.9448 376.243 88.7068 376.758 88.8713 377.23C89.0357 377.702 89.5533 377.954 90.0311 377.781C92.2004 377.011 94.4659 375.148 97.0904 372.985C101.031 369.742 105.479 366.105 110.819 365.154C111.496 366.261 112.135 367.39 112.707 368.546C114.308 371.792 115.247 375.304 115.956 378.855C116.476 382.024 116.692 385.231 116.787 388.477C112.709 387.963 108.585 389.238 105.189 390.292C102.825 391.028 100.773 391.66 99.2591 391.582C98.8736 391.564 98.5424 391.859 98.5297 392.236C98.5114 392.622 98.8068 392.953 99.184 392.966C100.953 393.059 103.105 392.386 105.599 391.617C109.104 390.528 113.02 389.329 116.848 389.892C116.913 393.539 116.834 397.222 116.785 400.913C116.765 404.938 116.826 409.004 117.05 413.06C114.293 411.747 111.116 411.49 108.462 411.296C106.488 411.149 104.777 411.022 103.665 410.527C103.379 410.395 103.052 410.524 102.926 410.801C102.8 411.078 102.923 411.414 103.2 411.54C104.496 412.122 106.287 412.255 108.377 412.408C111.258 412.622 114.483 412.863 117.142 414.339C117.346 417.368 117.641 420.387 118.15 423.393C119.369 430.842 121.53 438.165 124.757 444.976C131.11 458.699 140.929 470.366 151.725 480.582C146.792 474.998 141.792 469.477 137.641 463.322C133.343 457.296 129.483 450.94 126.647 444.138C123.794 437.362 121.654 430.294 120.584 423.017C120.562 422.906 120.554 422.793 120.546 422.679C120.618 422.643 120.696 422.599 120.749 422.538C122.938 419.768 126.46 418.546 129.568 417.455C131.537 416.767 133.243 416.167 134.337 415.276C134.573 415.086 134.605 414.733 134.415 414.497C134.224 414.26 133.872 414.228 133.636 414.419C132.692 415.194 131.073 415.756 129.198 416.411C126.312 417.422 122.776 418.683 120.377 421.3C119.476 414.595 119.383 407.783 119.492 400.938C119.487 400.622 119.489 400.298 119.498 399.979C123.08 397.772 127.524 397.616 131.471 397.499C134.078 397.422 136.334 397.348 137.978 396.695C138.339 396.552 138.505 396.145 138.37 395.789C138.236 395.434 137.826 395.255 137.465 395.397C136.048 395.963 133.907 396.029 131.435 396.101C127.754 396.216 123.274 396.372 119.514 398.362C119.549 391.769 119.566 385.08 118.399 378.413C118.247 377.636 118.067 376.864 117.887 376.092C120.46 371.013 125.612 367.887 130.159 365.124C133.064 363.367 135.57 361.846 137.019 360.05C137.332 359.657 137.27 359.085 136.878 358.773C136.444 358.469 135.872 358.53 135.546 358.926Z",
    fill: "#E6E9F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9221 336.753C84.671 337.127 84.0998 337.08 83.8796 336.691C78.8397 327.503 82.7966 323.09 81.7952 317.825C80.9077 313.178 86.121 322.663 89.2586 324.485C91.8843 326.01 86.6692 334.156 84.9221 336.753Z",
    fill: "#B5EFF9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.598 348.945C108.176 349.179 107.65 348.849 107.635 348.369C107.336 337.08 113.295 334.797 114.927 329.254C116.362 324.362 116.69 336.021 118.804 339.311C120.57 342.078 111.559 347.321 108.598 348.945Z",
    fill: "#B5EFF9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.707 369.088C123.161 369.094 122.814 368.499 123.043 368.015C128.627 356.598 135.76 357.443 140.275 352.755C144.259 348.625 138.504 360.422 138.894 364.806C139.225 368.488 127.504 369.015 123.707 369.088Z",
    fill: "#B5EFF9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.665 397.728C125.294 397.527 125.291 396.994 125.633 396.754C133.68 391.224 138.143 394.48 142.93 393.06C147.151 391.802 138.846 397.519 137.454 400.609C136.273 403.189 128.227 399.114 125.665 397.728Z",
    fill: "#B5EFF9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.176 419.021C124.846 418.956 124.709 418.55 124.918 418.293C129.723 412.137 133.911 413.544 137.226 411.303C140.147 409.326 135.189 415.693 134.864 418.379C134.591 420.63 127.474 419.458 125.176 419.021Z",
    fill: "#B5EFF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3193 341.995C70.5373 341.599 70.2398 341.11 69.7905 341.097C59.319 340.79 57.1879 346.322 52.0396 347.812C47.4993 349.133 58.3147 349.467 61.3657 351.435C63.9215 353.082 68.8074 344.726 70.3193 341.995Z",
    fill: "#B5EFF9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.072 352.046C88.2985 351.619 87.9651 351.094 87.4825 351.095C76.1892 350.97 74.0035 356.96 68.4826 358.681C63.6115 360.189 75.2846 360.34 78.5987 362.401C81.3844 364.119 86.4952 355.034 88.072 352.046Z",
    fill: "#B5EFF9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.921 368.241C103.109 367.729 102.659 367.197 102.124 367.259C89.506 368.762 87.9374 375.77 82.035 378.488C76.8191 380.885 89.8556 379.35 93.864 381.167C97.2247 382.693 101.594 371.808 102.921 368.241Z",
    fill: "#B5EFF9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M111.117 389.954C111.396 389.647 111.237 389.13 110.835 389.029C101.425 386.41 98.2689 390.94 93.2812 391.152C88.8788 391.336 98.5887 394.048 100.914 396.504C102.852 398.567 109.131 392.1 111.117 389.954Z",
    fill: "#B5EFF9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.969 412.785C113.272 412.639 113.296 412.209 113.033 412.008C106.79 407.315 103.119 409.762 99.333 408.456C95.9957 407.308 102.443 412.164 103.453 414.675C104.299 416.787 110.871 413.808 112.969 412.785Z",
    fill: "#B5EFF9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1785 336.759C73.3517 337.129 73.0449 337.549 72.6372 337.528C63.1703 337.089 61.633 331.957 57.0916 330.252C53.0873 328.751 62.8649 329.195 65.7504 327.628C68.1661 326.313 71.9967 334.181 73.1785 336.759Z",
    fill: "#B5EFF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 598,
    height: 568,
    fill: "#F0F5F8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.42 438.88C106.88 437.6 106.35 436.3 105.83 435",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.63 243.31C469.29 244.55 469.94 245.79 470.59 247.02",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9398 407.07C47.1298 389.68 44.5298 371.14 48.8398 353.47C54.1498 331.74 72.0098 312.07 94.2898 309.98C122.32 307.36 148.01 331.65 175.91 327.85C196.37 325.07 211.98 307.54 220.49 288.73C229 269.92 232.28 249.17 239.43 229.8C248.94 204.06 265.94 180.44 289.67 166.66C313.4 152.88 344.18 150.13 368.42 162.98C390.67 174.78 404.57 197.17 416.63 219.58",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10,
    strokeDasharray: "8.44 8.44"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.833 451.056C389.516 458.201 397.859 462.03 403.005 464.035C407.579 465.812 411.384 466.816 413.72 467.345C422.024 469.232 441.586 472.723 445.776 465.598C449.758 458.808 437.386 446.061 435.744 444.523C440.344 447.611 448.523 452.294 459.841 454.026C461.94 454.35 468.058 455.313 474.305 455.144C477.43 455.068 480.585 454.696 483.299 453.82C484.641 453.38 485.893 452.808 486.955 452.081C488.017 451.355 488.899 450.482 489.689 449.341C493.702 443.53 488.994 433.903 479.618 426.207C481.67 425.759 484.641 424.969 487.626 423.903C490.668 422.828 493.892 421.431 497.157 419.746C497.973 419.312 499.799 418.365 501.997 417.134C504.214 415.899 506.759 414.398 509.386 412.805C514.711 409.57 521.066 405.535 521.2 400.261C521.283 397.033 519.276 394.19 516.824 391.915C514.373 389.641 511.312 388 509.621 387.182C507.019 385.906 504.085 385.112 501.248 384.741C498.423 384.378 495.718 384.405 493.309 384.628C488.451 385.08 484.775 386.267 482.73 386.937C475.804 389.184 474.143 390.183 471.389 392.322C474.529 385.444 475.306 379.443 474.518 374.796C473.738 370.138 471.252 366.865 468.311 365.245C467.338 364.71 466.272 364.443 465.182 364.327C464.17 364.217 462.82 364.366 461.476 364.671C458.777 365.271 455.917 366.512 453.225 367.94C447.85 370.803 443.189 374.468 442.014 375.398C430.34 384.636 425.713 395.826 423.915 401.66C424.538 396.756 426.64 380.117 419.276 377.65C415.022 376.222 408.727 379.965 402.74 385.256C396.761 390.536 391.05 397.419 387.855 401.958C386.112 404.441 382.659 409.616 379.73 416.713C375.496 427.013 374.808 435.074 374.656 436.794C374.361 440.222 374.399 443.119 374.54 445.201C375.932 446.643 378.046 448.758 380.833 451.056Z",
    fill: "#71C285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.992 451.76C360.992 451.76 362.995 450.823 366.439 449.099C368.159 448.227 370.241 447.18 372.648 446.032C375.035 444.888 377.825 443.697 380.876 442.377C393.04 437.084 409.595 430.567 426.756 424.722C443.917 418.877 461.578 413.477 475.557 409.295C482.557 407.202 488.565 405.249 493.206 403.936C497.846 402.623 501.09 401.895 502.349 401.546",
    stroke: "#6DB37E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.618 418.227C452.514 404.815 458.729 391.449 465.048 378.125",
    stroke: "#6DB37E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.892 420.368C453.266 427.678 465.377 435.235 477.405 442.884",
    stroke: "#6DB37E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.886 435.968C399.417 422.913 404.601 409.859 410.121 396.898",
    stroke: "#C4422B",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.45 438.369C404.211 445.105 417.36 452.388 430.242 460.015",
    stroke: "#6DB37E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.919 448.583C362.121 447.756 363.603 447.4 364.854 447.062C366.651 446.548 368.365 445.872 370.019 445.138C371.674 444.403 373.292 443.558 374.829 442.94C377.929 441.622 380.909 440.586 383.698 439.815C389.273 438.254 394.066 437.705 397.51 437.978C402.927 438.401 407.694 439.864 412.328 440.627C416.989 441.376 421.365 441.567 426.454 438.983C427.95 438.235 433.982 435.158 434.814 430.104C435.238 427.473 434.031 425.846 429.38 417.905C423.719 408.295 422.782 406.107 423.687 404.227C424.794 401.905 428.082 401.209 430.5 400.674C436.299 399.359 438.329 401.916 444.047 400.156C445.708 399.644 448.877 398.627 449.758 396.176C450.649 393.665 448.253 392.219 448.881 390.374C449.492 388.6 452.249 388.477 455.969 388.043C459.692 387.628 464.378 386.901 468.653 384.166C473.648 380.945 477.984 375.199 476.626 371.248C475.763 368.678 472.822 367.476 469.988 366.335C461.216 362.751 455.088 366.077 452.127 362.092C451.915 361.805 450.562 359.938 451.095 358.108C452.008 355.009 457.365 355.724 462.975 351.536C463.724 350.986 464.951 350.077 465.928 349.004C466.929 347.898 467.605 346.775 467.469 345.384C467.376 343.841 466.111 343.246 464.828 342.605C463.546 341.964 462.255 341.266 461.912 339.743C461.291 337.163 464.321 335.408 466.231 330.092C466.434 329.533 467.241 327.231 467.59 324.68C467.92 322.133 467.875 319.314 466.365 317.502C465.306 316.25 463.516 315.545 461.49 315.423C459.452 315.294 457.199 315.764 455.281 316.677C450.339 319.082 448.385 323.947 446.29 328.357C446.015 328.947 445.786 329.403 445.433 330.054C445.03 330.753 444.621 331.481 444.209 332.19C443.378 333.62 442.511 335.075 441.559 336.486C439.659 339.325 437.439 342.051 434.561 344.385C432.726 345.879 430.654 347.168 428.28 346.947C424.224 346.568 423.093 342.21 419.718 341.098C417.331 340.313 414.133 341.024 411.28 342.604C408.426 344.184 405.953 346.61 404.877 349.424C403.454 353.112 404.871 356.401 406.368 360.368C407.854 364.328 409.445 369.002 408.101 375.415C407.862 376.652 406.165 383.833 402.933 384.033C399.94 384.204 399.053 378.092 393.3 374.859C388.83 372.335 382.167 371.801 378.371 374.547C376.986 375.559 376.085 376.922 375.553 380.331C375.012 383.75 374.846 389.184 374.657 398.529C374.061 417.381 374.882 419.938 372.994 425.386C372.197 427.697 370.923 430.436 368.819 433.396C368.285 434.135 367.705 434.891 367.069 435.656C366.456 436.388 365.656 437.287 365.102 437.844C363.862 439.096 362.297 440.264 360.324 441.021C359.945 441.15 359.567 441.279 359.161 441.422C358.597 441.669 357.99 441.952 357.426 442.267C358.585 442.986 358.803 444.218 359.108 445.445C359.44 446.658 359.865 447.905 360.919 448.583Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.421 444.162C360.421 444.162 360.572 444.069 360.892 443.881C361.143 443.743 361.52 443.546 362.04 443.267C363.135 442.682 364.825 441.62 366.726 439.94C368.827 437.984 371.378 435.614 374.242 432.95C380.049 427.513 387.076 420.875 394.107 414.14C401.154 407.45 408.078 400.537 413.648 394.475C419.219 388.413 423.439 383.222 425.302 380.271C427.357 377.007 430.405 372.161 433.683 366.624C436.961 361.088 440.46 354.873 443.793 349.074C445.48 346.181 447.103 343.377 448.6 340.817C450.123 338.291 451.515 335.991 452.683 334.049C453.748 332.251 454.531 330.702 455.085 329.609C455.629 328.508 455.92 327.896 455.92 327.896",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.298 380.252C423.138 370.838 420.587 361.662 417.805 352.62",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.278 375.524C439.103 376.01 450.139 375.927 461.078 375.791",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.117 418.909C388.326 408.319 387.487 397.913 386.304 387.61",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.552 415.618C402.184 419.035 411.885 422.401 421.675 425.597",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.743 388.724C425.384 390.031 432.082 391.211 438.828 392.258",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.813 445.76C347.055 443.953 368.328 412.896 371.397 396.624C371.908 393.929 372.602 390.247 371.437 385.834C369.883 379.999 366.741 379.23 363.643 372.491C361.069 366.87 359.322 358.846 361.821 357.229C363.454 356.168 366.967 357.798 368.972 360.112C372.562 364.269 369.589 368.735 373.335 373.554C374.972 375.646 377.868 377.78 379.704 376.993C381.54 376.206 381.654 372.802 381.698 371.629C381.883 366.84 379.922 363.352 376.135 356.982C370.833 348.059 368.9 345.206 366.983 339.933C364.158 332.144 365.43 330.295 365.961 329.706C367.714 327.718 371.832 327.545 374.109 329.337C375.485 330.416 375.532 331.697 376.864 339.886C377.38 343.09 377.888 346.014 379.125 349.655C380.521 353.748 381.644 355.235 383.037 355.502C383.924 355.678 384.963 355.351 385.631 354.777C389.418 351.553 383.741 338.409 381.853 334.002C379.83 329.286 378.15 326.551 376.641 320.771C374.809 313.742 375.784 311.953 376.665 311.173C378.001 310.025 380.32 310.179 381.841 310.94C382.933 311.475 384.474 312.736 386.101 319.405C387.132 323.594 387.499 327.093 387.68 329.125C388.358 336.757 387.702 339.917 389.76 341.193C390.726 341.785 392.4 342.043 393.521 341.31C398.7 337.973 392.12 314.583 388.102 302.975C386.43 298.153 384.471 293.23 386.791 290.427C388.643 288.215 392.811 287.739 395.365 289.352C398.63 291.414 398.493 296.429 398.404 299.83C398.27 304.783 396.779 305.355 396.143 311.91C395.472 319.011 396.958 321.078 397.678 321.894C398.654 323.001 400.732 324.629 402.483 324.076C403.311 323.808 404.971 322.768 406.2 311.97C407.289 302.36 406.342 299.838 408.698 296.489C410.863 293.405 414.923 290.885 417.147 292.048C419.235 293.135 419.345 297.313 418.871 299.929C418.103 304.15 415.722 304.902 412.366 312.092C410.505 316.073 410.429 317.582 411.099 318.467C412.132 319.847 414.716 319.516 415.389 319.432C422.435 318.542 423.171 310.853 431.824 306.539C433.868 305.522 438.127 303.4 442.653 304.916C446.4 306.164 450.37 309.941 450.267 314.558C450.159 319.213 446.005 322.594 442.699 323.924C437.636 325.93 435.469 322.759 425.642 322.76C421.801 322.754 413.359 322.741 411.174 327.227C411.045 327.493 410.024 329.608 410.95 331.164C412.783 334.243 419.569 330.904 428.853 333.321C431.273 333.949 437.614 335.613 438.071 339.134C438.41 341.767 435.382 344.905 432.206 345.674C430.067 346.178 428.789 345.403 422.204 342.76C414.177 339.539 412.321 339.212 410.293 339.417C407.358 339.706 403.42 341.15 403.053 343.442C402.721 345.569 405.591 347.621 408.107 349.375C415.07 354.215 418.767 352.87 424.452 357.315C426.221 358.699 430.419 361.985 429.714 365.3C429.275 367.371 427.012 369.011 424.87 369.344C420.934 369.967 417.348 366.214 414.132 362.856C411.181 359.773 411.417 358.95 408.231 355.931C405.115 352.961 402.913 350.948 400.213 351.322C397.995 351.643 395.532 353.561 395.439 355.649C395.359 357.662 397.527 358.785 405.532 364.377C407.149 365.503 409.659 367.38 414.677 371.11C421.508 376.192 423.077 377.559 423.051 379.526C423.025 381.726 421.028 384.023 418.983 384.279C418.2 384.368 417.046 384.211 413.521 380.988C410.226 377.974 410.184 377.183 407.654 374.806C403.797 371.196 400.693 370.052 399.036 369.595C397.328 369.122 395.39 368.588 394.25 369.582C392.849 370.789 393.232 373.77 394.127 375.748C395.558 378.915 398.109 379.216 405.768 383.502C413.725 387.961 415.183 389.774 415.72 391.663C415.8 391.932 416.679 395.25 414.863 397.15C413.191 398.88 410.286 398.366 408.936 398.13C404.052 397.286 400.675 393.536 399.541 392.21C397.322 389.636 397.017 387.894 394.381 386.454C393.626 386.036 391.809 385.04 389.773 385.344C387.435 385.684 385.452 387.611 383.378 391.564C379.972 398.064 379.884 403.304 379.031 407.907C378.098 413.002 375.374 417.796 369.913 427.374C366.319 433.695 361.018 441.911 353.392 450.771C350.831 449.11 348.317 447.442 345.813 445.76Z",
    fill: "#71C285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.017 402.296C299.017 402.296 300.204 401.744 302.24 400.715C303.26 400.209 304.492 399.572 305.914 398.904C307.325 398.229 308.975 397.524 310.787 396.735C317.988 393.597 327.783 389.748 337.952 386.286C348.111 382.817 358.568 379.631 366.839 377.148C370.975 375.907 374.54 374.757 377.288 373.973C380.028 373.2 381.955 372.763 382.692 372.556",
    stroke: "#805333",
    strokeWidth: 1.6688,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.707 382.443C353.192 374.506 356.876 366.595 360.62 358.693",
    stroke: "#805333",
    strokeWidth: 1.6688,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.325 383.709C353.649 388.043 360.809 392.511 367.941 397.041",
    stroke: "#805333",
    strokeWidth: 1.6688,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.092 392.951C321.773 385.221 324.842 377.487 328.109 369.829",
    stroke: "#805333",
    strokeWidth: 1.6688,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.467 394.378C324.611 398.365 332.4 402.683 340.016 407.194",
    stroke: "#805333",
    strokeWidth: 1.6688,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M189.965 185.08L173.721 175.712L173.721 182.299L189.965 191.667L189.965 185.08Z",
    fill: "#A0BED0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M225.859 164.379L189.965 185.08L189.965 191.667L225.859 170.966L225.859 164.379Z",
    fill: "#A0BED0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M225.839 164.368L214.067 171.173L204.615 176.632L200.598 178.928L196.819 181.151L189.976 185.091L173.711 175.722L184.913 169.26L188.723 167.067L192.709 164.741L202.151 159.312L209.615 155L225.839 164.368Z",
    fill: "#C0D8E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.036 174.513C190.659 173.716 190.824 172.331 192.419 171.41L202.151 165.806C203.745 164.886 206.157 164.782 207.534 165.578C208.911 166.375 208.746 167.76 207.151 168.681L197.419 174.285C195.835 175.216 193.423 175.309 192.036 174.513Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M187.781 188.906L175.492 196L175.492 192.391L187.781 185.297L187.781 188.906Z",
    fill: "#8EACBE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M175.492 196L164 189.372L164 185.763L175.492 192.391L175.492 196Z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M174.892 195.09L164.601 189.154L164.601 186.673L174.892 192.608L174.892 195.09Z",
    fill: "#8EACBE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M164 185.773L175.492 192.402L187.781 185.308L176.289 178.68L164 185.773Z",
    fill: "#C0D7E5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M169.311 188.834L170.18 189.33L182.469 182.247L181.61 181.751L169.311 188.834Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.463 182.34L175.44 183.478L172.324 185.277L170.336 184.139L173.463 182.34Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M181.445 186.942L179.467 185.804L176.341 187.603L178.329 188.741L181.445 186.942Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.598 178.928L196.819 181.151L184.913 169.259L188.723 167.067L200.598 178.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M214.067 171.173L204.615 176.632L192.709 164.741L202.151 159.312L214.067 171.173Z",
    fill: "white"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M193.41 392.43C203.455 380.187 208.83 368.429 211.644 361.178C214.136 354.733 215.542 349.372 216.284 346.081C218.923 334.384 223.801 306.827 213.757 300.94C204.187 295.346 186.261 312.796 184.098 315.111C188.437 308.627 195.016 297.099 197.432 281.156C197.884 278.2 199.227 269.582 198.977 260.785C198.864 256.384 198.334 251.941 197.095 248.121C196.472 246.232 195.664 244.47 194.638 242.976C193.613 241.482 192.382 240.241 190.774 239.13C182.582 233.491 169.034 240.141 158.215 253.361C157.58 250.472 156.461 246.29 154.954 242.088C153.434 237.807 151.46 233.269 149.08 228.674C148.467 227.525 147.13 224.956 145.391 221.863C143.648 218.743 141.529 215.162 139.281 211.466C134.713 203.974 129.018 195.032 121.591 194.854C117.044 194.743 113.044 197.576 109.846 201.033C106.648 204.49 104.344 208.804 103.195 211.187C101.403 214.854 100.291 218.988 99.7748 222.983C99.2694 226.963 99.3125 230.772 99.6311 234.165C100.277 241.004 101.956 246.18 102.905 249.059C106.083 258.808 107.492 261.145 110.511 265.018C100.818 260.611 92.366 259.529 85.823 260.648C79.2645 261.756 74.6609 265.264 72.3844 269.408C71.633 270.779 71.2597 272.281 71.0978 273.817C70.9453 275.242 71.1584 277.142 71.5898 279.035C72.4413 282.835 74.194 286.86 76.2103 290.649C80.2542 298.212 85.4245 304.769 86.7365 306.422C99.77 322.844 115.539 329.337 123.758 331.857C116.851 330.99 93.4137 328.064 89.9549 338.439C87.9518 344.433 93.2356 353.291 100.699 361.711C108.147 370.121 117.853 378.149 124.251 382.639C127.752 385.089 135.046 389.942 145.048 394.052C159.561 399.994 170.915 400.947 173.337 401.157C178.166 401.566 182.246 401.506 185.178 401.303C187.205 399.34 190.179 396.359 193.41 392.43Z",
    fill: "#71C285"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M193.999 419.785C193.999 419.785 192.676 416.967 190.241 412.12C189.01 409.699 187.531 406.769 185.91 403.382C184.293 400.022 182.611 396.096 180.746 391.801C173.267 374.682 164.055 351.38 155.789 327.225C147.522 303.069 139.882 278.208 133.963 258.529C131.002 248.676 128.239 240.218 126.381 233.686C124.522 227.153 123.491 222.586 122.997 220.814",
    stroke: "#6DB27E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M147.045 299.851C128.145 291.575 109.309 282.85 90.5312 273.978",
    stroke: "#6DB27E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M150.07 307.909C160.34 290.469 170.958 273.398 181.704 256.443",
    stroke: "#6DB27E",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M172.134 372.669C153.739 366.315 135.345 359.041 117.08 351.293",
    stroke: "#579E69",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M175.523 378.911C184.981 359.517 195.211 340.986 205.926 322.828",
    stroke: "#579E69",
    strokeWidth: 2.0192,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M191.454 425.591C190.625 424.391 190.267 422.909 189.927 421.658C189.411 419.862 188.733 418.149 187.996 416.496C187.259 414.842 186.412 413.226 185.791 411.689C184.469 408.591 183.429 405.612 182.653 402.824C181.084 397.252 180.529 392.46 180.797 389.015C181.212 383.597 182.668 378.829 183.424 374.194C184.166 369.532 184.351 365.155 181.76 360.07C181.01 358.575 177.924 352.547 172.869 351.722C170.237 351.303 168.612 352.512 160.677 357.175C151.075 362.849 148.889 363.79 147.008 362.887C144.684 361.784 143.984 358.497 143.445 356.08C142.121 350.282 144.675 348.249 142.907 342.533C142.394 340.872 141.372 337.706 138.919 336.828C136.407 335.941 134.965 338.339 133.118 337.713C131.343 337.105 131.216 334.348 130.777 330.629C130.357 326.906 129.624 322.221 126.882 317.95C123.654 312.959 117.901 308.632 113.952 309.996C111.384 310.862 110.186 313.805 109.049 316.641C105.478 325.418 108.813 331.541 104.832 334.508C104.545 334.72 102.68 336.076 100.849 335.546C97.7486 334.637 98.4558 329.279 94.26 323.676C93.7094 322.927 92.7986 321.701 91.7239 320.726C90.616 319.727 89.4927 319.052 88.1021 319.19C86.5584 319.286 85.9652 320.552 85.3261 321.835C84.6869 323.118 83.9909 324.41 82.4682 324.755C79.8898 325.38 78.1304 322.352 72.8117 320.45C72.2527 320.248 69.9486 319.444 67.3976 319.099C64.8497 318.772 62.0315 318.822 60.2212 320.334C58.971 321.395 58.2682 323.186 58.1497 325.212C58.0231 327.25 58.4967 329.503 59.4128 331.42C61.8242 336.358 66.692 338.305 71.1054 340.394C71.6958 340.668 72.1519 340.896 72.8037 341.248C73.5026 341.651 74.2317 342.058 74.9417 342.469C76.3728 343.298 77.829 344.163 79.2407 345.112C82.0829 347.009 84.8117 349.225 87.1504 352.1C88.6472 353.932 89.9391 356.002 89.7211 358.377C89.3479 362.433 84.9916 363.57 83.8842 366.947C83.1032 369.335 83.8182 372.532 85.4027 375.383C86.9873 378.234 89.4161 380.704 92.2316 381.776C95.9217 383.194 99.2086 381.772 103.174 380.269C107.132 378.778 111.803 377.18 118.218 378.514C119.456 378.752 126.64 380.438 126.844 383.67C127.019 386.663 120.908 387.559 117.683 393.317C115.166 397.79 114.642 404.454 117.393 408.245C118.407 409.63 119.772 410.529 123.181 411.056C126.601 411.591 132.035 411.75 141.381 411.926C160.233 412.494 162.789 411.669 168.24 413.55C170.552 414.343 173.293 415.613 176.256 417.713C176.996 418.246 177.752 418.825 178.518 419.46C179.251 420.072 180.151 420.871 180.709 421.423C181.963 422.662 183.133 424.225 183.893 426.197C184.022 426.576 184.152 426.954 184.296 427.359C184.544 427.923 184.828 428.53 185.143 429.093C185.861 427.933 187.092 427.714 188.319 427.407C189.532 427.073 190.778 426.646 191.454 425.591Z",
    fill: "#3B97D3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M187.033 426.096C187.033 426.096 186.941 425.945 186.752 425.625C186.614 425.375 186.416 424.997 186.137 424.478C185.55 423.384 184.486 421.696 182.802 419.796C180.843 417.698 178.47 415.151 175.802 412.291C170.357 406.491 163.709 399.474 156.963 392.453C150.263 385.416 143.34 378.502 137.27 372.94C131.2 367.378 126.003 363.166 123.05 361.307C119.783 359.256 114.932 356.215 109.391 352.946C103.85 349.676 97.6293 346.185 91.8259 342.861C88.9306 341.178 86.1236 339.559 83.5613 338.065C81.0338 336.547 78.732 335.157 76.7883 333.992C74.988 332.931 73.4382 332.15 72.3444 331.597C71.2427 331.055 70.6303 330.764 70.6303 330.764",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M123.031 361.31C113.62 363.484 104.447 366.048 95.4102 368.844",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M118.299 358.338C118.769 347.512 118.67 336.477 118.518 325.538",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M161.74 397.436C151.151 398.242 140.745 399.097 130.444 400.295",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M158.443 394.006C161.846 384.369 165.198 374.663 168.38 364.868",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M131.511 367.854C132.809 361.211 133.979 354.51 135.016 347.764",
    stroke: "#3486BA",
    strokeWidth: 1.5352,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M184.692 432.188C183.255 431.203 158.566 414.344 145.639 411.925C143.498 411.523 140.573 410.975 137.07 411.906C132.438 413.147 131.831 415.643 126.482 418.111C122.021 420.162 115.651 421.559 114.363 419.575C113.519 418.28 114.809 415.488 116.645 413.893C119.942 411.037 123.493 413.393 127.316 410.413C128.975 409.11 130.666 406.808 130.039 405.351C129.413 403.893 126.709 403.807 125.777 403.773C121.973 403.632 119.206 405.193 114.151 408.208C107.071 412.429 104.807 413.967 100.621 415.496C94.4388 417.749 92.9689 416.74 92.5008 416.32C90.9201 414.93 90.7778 411.659 92.1986 409.849C93.0537 408.755 94.0706 408.716 100.573 407.649C103.117 407.235 105.439 406.828 108.328 405.841C111.578 404.728 112.758 403.835 112.968 402.728C113.106 402.024 112.845 401.199 112.389 400.669C109.825 397.665 99.392 402.188 95.8945 403.693C92.1514 405.306 89.9813 406.643 85.3923 407.847C79.8122 409.31 78.3904 408.538 77.7701 407.84C76.857 406.78 76.9764 404.938 77.5789 403.729C78.0029 402.861 79.0023 401.636 84.2971 400.336C87.6227 399.513 90.4008 399.217 92.0143 399.071C98.0747 398.524 100.586 399.041 101.596 397.405C102.066 396.637 102.268 395.308 101.685 394.419C99.0286 390.309 80.4602 395.561 71.2458 398.766C67.4184 400.1 63.5111 401.661 61.2822 399.821C59.523 398.353 59.1406 395.043 60.4183 393.013C62.0524 390.418 66.0355 390.521 68.7362 390.588C72.6703 390.689 73.1259 391.872 78.333 392.37C83.9733 392.895 85.6131 391.712 86.2605 391.139C87.138 390.363 88.4285 388.71 87.9879 387.32C87.7738 386.663 86.9456 385.346 78.3688 384.382C70.7356 383.529 68.7339 384.283 66.0717 382.416C63.6194 380.7 61.614 377.479 62.5349 375.712C63.3953 374.052 66.7134 373.96 68.7915 374.333C72.1448 374.938 72.7447 376.828 78.459 379.485C81.6223 380.959 82.8208 381.017 83.5234 380.484C84.6177 379.663 84.3521 377.611 84.2846 377.076C83.5694 371.481 77.4628 370.906 74.0263 364.039C73.2166 362.416 71.5266 359.037 72.725 355.44C73.7123 352.463 76.707 349.306 80.3739 349.382C84.0708 349.463 86.7606 352.758 87.821 355.382C89.42 359.4 86.9036 361.125 86.916 368.929C86.9153 371.98 86.9145 378.685 90.4801 380.415C90.6916 380.517 92.3727 381.325 93.6074 380.588C96.05 379.129 93.3905 373.743 95.2994 366.367C95.7955 364.445 97.1102 359.407 99.9059 359.04C101.996 358.768 104.492 361.169 105.106 363.69C105.509 365.389 104.895 366.405 102.803 371.637C100.254 378.016 99.9973 379.49 100.162 381.101C100.395 383.431 101.546 386.557 103.367 386.846C105.057 387.107 106.683 384.825 108.073 382.825C111.909 377.29 110.837 374.355 114.36 369.835C115.457 368.429 118.062 365.091 120.696 365.647C122.341 365.993 123.646 367.789 123.913 369.49C124.412 372.615 121.436 375.467 118.772 378.025C116.328 380.372 115.674 380.186 113.279 382.719C110.925 385.197 109.328 386.948 109.629 389.092C109.886 390.853 111.412 392.807 113.071 392.879C114.669 392.94 115.558 391.217 119.99 384.853C120.882 383.568 122.37 381.572 125.327 377.582C129.356 372.152 130.439 370.904 132.001 370.922C133.749 370.94 135.575 372.524 135.781 374.147C135.853 374.769 135.729 375.686 133.174 378.489C130.784 381.109 130.156 381.143 128.271 383.155C125.408 386.223 124.503 388.69 124.142 390.006C123.768 391.363 123.346 392.903 124.137 393.807C125.097 394.918 127.464 394.611 129.034 393.897C131.548 392.758 131.784 390.731 135.179 384.644C138.711 378.319 140.15 377.159 141.649 376.73C141.862 376.666 144.497 375.965 146.008 377.405C147.383 378.731 146.979 381.038 146.793 382.111C146.128 385.991 143.154 388.677 142.102 389.579C140.06 391.344 138.677 391.588 137.536 393.684C137.205 394.284 136.417 395.727 136.66 397.345C136.933 399.201 138.465 400.774 141.607 402.416C146.773 405.114 150.935 405.177 154.591 405.85C158.639 406.585 162.449 408.742 170.062 413.069C175.087 415.916 181.617 420.116 188.662 426.162C187.347 428.199 186.025 430.197 184.692 432.188Z",
    fill: "#71C285"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.77 448.16C191.19 448.16 189.09 446.06 189.09 443.48C189.09 440.9 191.19 438.8 193.77 438.8C196.35 438.8 198.45 440.9 198.45 443.48H195.76C195.76 442.38 194.87 441.49 193.77 441.49C192.67 441.49 191.78 442.38 191.78 443.48C191.78 444.58 192.67 445.47 193.77 445.47V448.16Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.071 381.72C198.491 381.72 196.391 379.62 196.391 377.04C196.391 374.46 198.491 372.36 201.071 372.36C203.651 372.36 205.751 374.46 205.751 377.04H203.061C203.061 375.94 202.171 375.05 201.071 375.05C199.971 375.05 199.081 375.94 199.081 377.04C199.081 378.14 199.971 379.03 201.071 379.03V381.72Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M136.02 376.61C133.44 376.61 131.34 374.51 131.34 371.93C131.34 369.35 133.44 367.25 136.02 367.25C138.6 367.25 140.7 369.35 140.7 371.93H138.01C138.01 370.83 137.12 369.94 136.02 369.94C134.92 369.94 134.03 370.83 134.03 371.93C134.03 373.03 134.92 373.92 136.02 373.92V376.61Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.19 331.54C188.61 331.54 186.51 329.44 186.51 326.86C186.51 324.28 188.61 322.18 191.19 322.18C193.77 322.18 195.87 324.28 195.87 326.86H193.18C193.18 325.76 192.29 324.87 191.19 324.87C190.09 324.87 189.2 325.76 189.2 326.86C189.2 327.96 190.09 328.85 191.19 328.85V331.54Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M190.08 283.58C187.5 283.58 185.4 281.48 185.4 278.9C185.4 276.32 187.5 274.22 190.08 274.22C192.66 274.22 194.76 276.32 194.76 278.9H192.07C192.07 277.8 191.18 276.91 190.08 276.91C188.98 276.91 188.09 277.8 188.09 278.9C188.09 280 188.98 280.89 190.08 280.89V283.58Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82.0999 345.96C79.5199 345.96 77.4199 343.86 77.4199 341.28C77.4199 338.7 79.5199 336.6 82.0999 336.6C84.6799 336.6 86.7799 338.7 86.7799 341.28H84.0899C84.0899 340.18 83.1999 339.29 82.0999 339.29C80.9999 339.29 80.1099 340.18 80.1099 341.28C80.1099 342.38 80.9999 343.27 82.0999 343.27V345.96Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.8802 292.81C41.3002 292.81 39.2002 290.71 39.2002 288.13C39.2002 285.55 41.3002 283.45 43.8802 283.45C46.4602 283.45 48.5602 285.55 48.5602 288.13H45.8702C45.8702 287.03 44.9802 286.14 43.8802 286.14C42.7802 286.14 41.8902 287.03 41.8902 288.13C41.8902 289.23 42.7802 290.12 43.8802 290.12V292.81Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170.491 238.81C167.911 238.81 165.811 236.71 165.811 234.13C165.811 231.55 167.911 229.45 170.491 229.45C173.071 229.45 175.171 231.55 175.171 234.13H172.481C172.481 233.03 171.591 232.14 170.491 232.14C169.391 232.14 168.501 233.03 168.501 234.13C168.501 235.23 169.391 236.12 170.491 236.12V238.81Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.451 182.31C163.871 182.31 161.771 180.21 161.771 177.63C161.771 175.05 163.871 172.95 166.451 172.95C169.031 172.95 171.131 175.05 171.131 177.63H168.441C168.441 176.53 167.551 175.64 166.451 175.64C165.351 175.64 164.461 176.53 164.461 177.63C164.461 178.73 165.351 179.62 166.451 179.62V182.31Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.321 146.55C151.741 146.55 149.641 144.45 149.641 141.87C149.641 139.29 151.741 137.19 154.321 137.19C156.901 137.19 159.001 139.29 159.001 141.87H156.311C156.311 140.77 155.421 139.88 154.321 139.88C153.221 139.88 152.331 140.77 152.331 141.87C152.331 142.97 153.221 143.86 154.321 143.86V146.55Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.4 120.36C135.82 120.36 133.72 118.26 133.72 115.68C133.72 113.1 135.82 111 138.4 111C140.98 111 143.08 113.1 143.08 115.68H140.39C140.39 114.58 139.5 113.69 138.4 113.69C137.3 113.69 136.41 114.58 136.41 115.68C136.41 116.78 137.3 117.67 138.4 117.67V120.36Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87.8206 131.28C85.2406 131.28 83.1406 129.18 83.1406 126.6C83.1406 124.02 85.2406 121.92 87.8206 121.92C90.4006 121.92 92.5006 124.02 92.5006 126.6H89.8106C89.8106 125.5 88.9206 124.61 87.8206 124.61C86.7206 124.61 85.8306 125.5 85.8306 126.6C85.8306 127.7 86.7206 128.59 87.8206 128.59V131.28Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.23 194.79C260.65 194.79 258.55 192.69 258.55 190.11C258.55 187.53 260.65 185.43 263.23 185.43C265.81 185.43 267.91 187.53 267.91 190.11H265.22C265.22 189.01 264.33 188.12 263.23 188.12C262.13 188.12 261.24 189.01 261.24 190.11C261.24 191.21 262.13 192.1 263.23 192.1V194.79Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M240.88 233.28C238.3 233.28 236.2 231.18 236.2 228.6C236.2 226.02 238.3 223.92 240.88 223.92C243.46 223.92 245.56 226.02 245.56 228.6H242.87C242.87 227.5 241.98 226.61 240.88 226.61C239.78 226.61 238.89 227.5 238.89 228.6C238.89 229.7 239.78 230.59 240.88 230.59V233.28Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M262.35 273.35C259.77 273.35 257.67 271.25 257.67 268.67C257.67 266.09 259.77 263.99 262.35 263.99C264.93 263.99 267.03 266.09 267.03 268.67H264.34C264.34 267.57 263.45 266.68 262.35 266.68C261.25 266.68 260.36 267.57 260.36 268.67C260.36 269.77 261.25 270.66 262.35 270.66V273.35Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M347.04 256.45C344.46 256.45 342.36 254.35 342.36 251.77C342.36 249.19 344.46 247.09 347.04 247.09C349.62 247.09 351.72 249.19 351.72 251.77H349.03C349.03 250.67 348.14 249.78 347.04 249.78C345.94 249.78 345.05 250.67 345.05 251.77C345.05 252.87 345.94 253.76 347.04 253.76V256.45Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M322.071 186.9C319.491 186.9 317.391 184.8 317.391 182.22C317.391 179.64 319.491 177.54 322.071 177.54C324.651 177.54 326.751 179.64 326.751 182.22H324.061C324.061 181.12 323.171 180.23 322.071 180.23C320.971 180.23 320.081 181.12 320.081 182.22C320.081 183.32 320.971 184.21 322.071 184.21V186.9Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.81 202.65C360.23 202.65 358.13 200.55 358.13 197.97C358.13 195.39 360.23 193.29 362.81 193.29C365.39 193.29 367.49 195.39 367.49 197.97H364.8C364.8 196.87 363.91 195.98 362.81 195.98C361.71 195.98 360.82 196.87 360.82 197.97C360.82 199.07 361.71 199.96 362.81 199.96V202.65Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M330.93 339.94C328.35 339.94 326.25 337.84 326.25 335.26C326.25 332.68 328.35 330.58 330.93 330.58C333.51 330.58 335.61 332.68 335.61 335.26H332.92C332.92 334.16 332.03 333.27 330.93 333.27C329.83 333.27 328.94 334.16 328.94 335.26C328.94 336.36 329.83 337.25 330.93 337.25V339.94Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M424.111 367.29C421.531 367.29 419.431 365.19 419.431 362.61C419.431 360.03 421.531 357.93 424.111 357.93C426.691 357.93 428.791 360.03 428.791 362.61H426.101C426.101 361.51 425.211 360.62 424.111 360.62C423.011 360.62 422.121 361.51 422.121 362.61C422.121 363.71 423.011 364.6 424.111 364.6V367.29Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.47 408.26C382.89 408.26 380.79 406.16 380.79 403.58C380.79 401 382.89 398.9 385.47 398.9C388.05 398.9 390.15 401 390.15 403.58H387.46C387.46 402.48 386.57 401.59 385.47 401.59C384.37 401.59 383.48 402.48 383.48 403.58C383.48 404.68 384.37 405.57 385.47 405.57V408.26Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M442.571 428.57C439.991 428.57 437.891 426.47 437.891 423.89C437.891 421.31 439.991 419.21 442.571 419.21C445.151 419.21 447.251 421.31 447.251 423.89H444.561C444.561 422.79 443.671 421.9 442.571 421.9C441.471 421.9 440.581 422.79 440.581 423.89C440.581 424.99 441.471 425.88 442.571 425.88V428.57Z",
    fill: "#B5EFF9"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M482.071 397.54C479.491 397.54 477.391 395.44 477.391 392.86C477.391 390.28 479.491 388.18 482.071 388.18C484.651 388.18 486.751 390.28 486.751 392.86H484.061C484.061 391.76 483.171 390.87 482.071 390.87C480.971 390.87 480.081 391.76 480.081 392.86C480.081 393.96 480.971 394.85 482.071 394.85V397.54Z",
    fill: "#B5EFF9"
  }))))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M161 284L254 250V319L161 284Z",
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 481,
    width: 16,
    height: 7,
    fill: "#E5E4E4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 461,
    width: 16,
    height: 7,
    fill: "#E5E4E4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178 461L256.707 445L364 481L287 508L178 461Z",
    fill: "#F4F4F4"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M161 284L286 331L287 508L178 461L161 284Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M286 331L389 303L364 481L287 508L286 331Z",
    fill: "#EDEDED"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M254 250L389 303.5L286 331L254 319.5V250Z",
    fill: "#FAFAFA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5 439.5L178 461L287 508L364 481L254.5 439.5Z",
    fill: "#F4F4F4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M286 331L293 329.5V506L287 508L286 331Z",
    fill: "#E9E9E9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M254 250L261 252.753V321.5L254 319V250Z",
    fill: "#FDFDFD"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M287 452V508L364 481L287 452Z",
    fill: "#D1D1D1",
    fillOpacity: 0.47
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M257.352 413.714C257.497 413.405 257.315 413.08 257.109 413.282C255.687 414.379 252.738 415.936 247.511 415.707C247.249 415.695 238.363 415.305 238.233 415.3C237.971 415.288 237.84 415.282 237.784 415.069C237.724 414.961 237.737 414.645 237.751 414.33L238.024 408.124C238.037 407.808 237.781 407.691 237.706 407.899C237.706 407.899 228.916 423.217 227.643 425.374C227.569 425.582 227.56 425.792 227.62 425.9C228.695 428.266 236.044 444.292 236.044 444.292C236.165 444.508 236.431 444.414 236.445 444.099L236.727 437.682C236.745 437.261 236.824 436.949 237.151 436.963C237.151 436.963 238.327 437.014 242.64 437.204C246.821 437.387 248.337 435.662 251.847 427.279L257.352 413.714Z",
    fill: "#46BA5F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M258.875 407.352C259.682 405.385 259.657 402.96 258.792 400.287L254.095 385.01C254.034 384.902 253.908 384.791 253.838 384.894L241.872 395.013C241.802 395.115 241.728 395.323 241.788 395.431L247.061 412.525C247.122 412.633 247.183 412.741 247.248 412.744C251.756 412.942 257.123 411.491 258.875 407.352Z",
    fill: "#46BA5F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M205.1 421.738C205.217 422.059 205.483 421.965 205.497 421.65C205.673 419.128 206.408 414.312 209.34 407.169C209.344 407.063 214.542 394.539 214.546 394.434C214.691 394.124 214.766 393.917 214.896 393.922C215.027 393.928 215.153 394.039 215.344 394.153L218.543 397.349C218.734 397.463 218.874 397.259 218.823 396.94C218.823 396.94 215.28 377.709 214.751 374.84C214.695 374.627 214.569 374.516 214.439 374.51C212.651 374.959 200.024 377.777 200.024 377.777C199.828 377.769 199.739 378.292 199.931 378.405L203.255 381.713C203.442 381.932 203.629 382.151 203.41 382.668C203.41 382.668 202.753 384.22 200.329 390.227C197.919 395.918 197.986 398.871 200.683 407.527L205.1 421.738Z",
    fill: "#46BA5F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M207.693 426.805C208.324 428.835 209.584 429.944 211.545 430.03L222.325 430.503C222.456 430.509 222.526 430.406 222.535 430.196L223.472 408.843C223.481 408.632 223.421 408.524 223.29 408.518L211.268 407.991C211.202 407.988 211.132 408.09 211.062 408.193C208.438 414.296 206.379 422.426 207.693 426.805Z",
    fill: "#46BA5F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.098 348.686C225.902 348.678 225.818 349.096 225.94 349.312C227.252 350.739 229.4 353.995 231.695 361.368C231.691 361.473 235.771 374.405 235.767 374.51C235.884 374.831 235.94 375.045 235.865 375.252C235.791 375.46 235.721 375.562 235.45 375.761L231.984 378.665C231.783 378.762 231.83 379.185 232.022 379.299C232.022 379.299 244.349 383.318 246.095 383.816C246.226 383.822 246.361 383.722 246.435 383.515C247.209 380.809 252.492 361.859 252.492 361.859C252.571 361.546 252.389 361.222 252.184 361.424L248.582 364.428C248.377 364.629 248.176 364.726 248.003 364.191C248.003 364.191 247.489 362.483 245.596 356.392C243.885 350.626 242.237 349.394 236.095 349.125L226.098 348.686Z",
    fill: "#46BA5F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M221.982 349.981C220.545 349.918 219.244 351.231 218.144 353.923L212.126 368.73C212.056 368.832 212.112 369.046 212.173 369.154L223.206 380.282C223.267 380.391 223.402 380.291 223.472 380.189L230.222 363.622C230.292 363.52 230.296 363.415 230.236 363.307C228.296 356.793 225.049 350.221 221.982 349.981Z",
    fill: "#46BA5F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M334.247 134.719L268.287 149.347C265.259 150.018 262.259 148.108 261.584 145.077L252.134 102.464C251.463 99.4362 253.373 96.436 256.404 95.7618L322.364 81.1344C325.392 80.463 328.392 82.3732 329.067 85.4043L338.517 128.017C339.188 131.048 337.278 134.048 334.247 134.719Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M321.188 100.536C321.821 97.2451 319.667 94.0636 316.377 93.4299C313.086 92.7962 309.904 94.9502 309.27 98.2411C308.637 101.532 310.791 104.713 314.082 105.347C317.373 105.981 320.554 103.827 321.188 100.536Z",
    fill: "#FF9F00"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M274.658 141.433L321.732 130.994C324.142 130.461 324.74 127.297 322.69 125.921L310.473 117.71C309.032 116.741 307.068 117.297 306.349 118.878L303.537 125.056C302.753 126.778 300.522 127.247 299.109 125.988L281.971 110.709C280.381 109.291 277.852 110.091 277.366 112.167L271.313 138.051C270.844 140.065 272.639 141.88 274.658 141.433Z",
    fill: "#0070CF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M203.451 124.129L162.147 132.659C160.679 132.963 159.245 132.017 158.941 130.549L147.057 72.9912C146.753 71.5234 147.699 70.0891 149.166 69.785L177.177 64.0024L196.145 75.3282L205.56 120.923C205.862 122.389 204.919 123.825 203.451 124.129Z",
    fill: "#E0E7EC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M177.177 64L179.408 74.8038C179.844 76.9109 181.903 78.2661 184.011 77.8303L196.146 75.3257L177.177 64Z",
    fill: "#AAC5D5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M190.93 83.5671L157.271 90.5158C156.888 90.5948 156.514 90.3482 156.435 89.965L156.124 88.4541C156.045 88.071 156.292 87.6975 156.672 87.6185L190.331 80.6698C190.714 80.5908 191.088 80.8374 191.167 81.2181L191.478 82.729C191.557 83.1145 191.313 83.488 190.93 83.5671Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M192.59 91.6027L158.931 98.5514C158.548 98.6305 158.175 98.3838 158.096 98.0031L157.784 96.4922C157.705 96.1091 157.952 95.7356 158.335 95.6566L191.994 88.7079C192.377 88.6288 192.75 88.8755 192.829 89.2586L193.141 90.7695C193.217 91.1502 192.973 91.5237 192.59 91.6027Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M194.249 99.6392L160.59 106.59C160.207 106.669 159.834 106.423 159.755 106.042L159.443 104.531C159.364 104.148 159.611 103.774 159.994 103.695L193.653 96.7467C194.036 96.6677 194.41 96.9143 194.489 97.295L194.8 98.8059C194.877 99.1866 194.632 99.5602 194.249 99.6392Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M195.908 107.677L162.25 114.626C161.866 114.705 161.493 114.458 161.414 114.077L161.103 112.566C161.024 112.183 161.27 111.81 161.653 111.731L195.312 104.782C195.695 104.703 196.069 104.95 196.148 105.33L196.459 106.841C196.536 107.224 196.291 107.598 195.908 107.677Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M197.568 115.713L163.909 122.661C163.526 122.74 163.152 122.494 163.073 122.111L162.762 120.6C162.683 120.217 162.929 119.843 163.31 119.764L196.969 112.816C197.352 112.737 197.726 112.983 197.805 113.364L198.116 114.875C198.195 115.26 197.951 115.634 197.568 115.713Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.889 248.773L275.483 234.452C274.507 234.123 274.11 232.956 274.683 232.1L293.232 208.946C293.625 208.359 294.363 208.108 295.032 208.334L337.439 222.655C338.415 222.984 338.555 224.07 338.238 225.007L319.689 248.16C319.297 248.748 318.559 248.999 317.889 248.773Z",
    fill: "#EFCE4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.232 208.946C293.624 208.359 294.362 208.108 295.032 208.334L327.5 219.298L331.339 207.929L321.927 188.918L300.136 181.56L289.179 214.005L293.232 208.946Z",
    fill: "#F4EFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.424 212.137L330.38 210.771L327.5 219.298L333.185 221.218L335.51 214.332C335.817 213.425 335.329 212.443 334.424 212.137Z",
    fill: "#EBBA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.617 191.981L290.678 189.976C289.772 189.67 288.789 190.156 288.483 191.063L274.812 231.545C274.877 231.569 274.941 231.595 275.003 231.62L289.19 213.973L296.617 191.981Z",
    fill: "#EBBA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.124 202.158L301.649 198.958C301.126 198.782 300.845 198.215 301.022 197.691C301.199 197.167 301.766 196.887 302.289 197.063L311.764 200.263C312.287 200.439 312.568 201.006 312.391 201.53C312.214 202.054 311.647 202.334 311.124 202.158Z",
    fill: "#CEC9AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.363 195.526L303.889 192.326C303.366 192.15 303.084 191.583 303.261 191.059C303.438 190.535 304.006 190.255 304.528 190.431L314.003 193.631C314.526 193.807 314.807 194.374 314.63 194.898C314.453 195.422 313.886 195.702 313.363 195.526Z",
    fill: "#CEC9AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.148 213.269L299.409 205.59C298.886 205.414 298.605 204.847 298.782 204.323C298.959 203.799 299.526 203.519 300.049 203.695L322.787 211.374C323.31 211.551 323.592 212.118 323.415 212.641C323.238 213.165 322.671 213.446 322.148 213.269Z",
    fill: "#CEC9AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.128 203.13L331.339 207.929L321.927 188.918L317.128 203.13Z",
    fill: "#D1BF86"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M389.91 107.52C385.53 105.86 383.31 100.91 384.97 96.5299C386.63 92.1499 391.58 89.9299 395.96 91.5899C400.34 93.2499 402.56 98.1999 400.9 102.58C399.24 106.96 394.29 109.18 389.91 107.52Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.3367,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M114.49 59.1299L127.04 71.6699",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M127.04 59.1299L114.49 71.6699",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M369.11 193.97L376.65 188.8L384.19 183.62L384.9 192.74L385.61 201.86L377.36 197.92L369.11 193.97Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.4271,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M62 193L74.55 205.54",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M74.55 193L62 205.54",
    stroke: "#DAEAF4",
    strokeWidth: 1.398,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22 269.21L22.89 260.1L23.79 251L31.23 256.33L38.66 261.66L30.33 265.43L22 269.21Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.4271,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M229.8 74.51L230.69 65.4L231.59 56.3L239.03 61.63L246.46 66.96L238.13 70.73L229.8 74.51Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.4271,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M429.541 150.444L423.924 143.217L418.321 135.99L427.388 134.745L436.448 133.507L432.991 141.972L429.541 150.444Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.4271,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4908 110.481C67.1108 108.821 64.8908 103.871 66.5508 99.4908C68.2108 95.1108 73.1608 92.8908 77.5408 94.5508C81.9208 96.2108 84.1408 101.161 82.4808 105.541C80.8208 109.921 75.8708 112.141 71.4908 110.481Z",
    stroke: "#DAEAF4",
    strokeWidth: 1.3367,
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404 220.031L441.111 240.508H444.243L500.97 209.206L460.727 187L404 218.302V220.031Z",
    fill: "#8EACBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.042 221.344L470.047 221.334H470.053C470.224 221.126 470.457 220.933 470.765 220.764C472.003 220.079 473.942 220.016 475.311 220.566H475.317C475.579 220.673 475.943 220.663 476.175 220.537L488.835 213.556C492.538 211.513 492.538 208.196 488.835 206.154L475.903 199.018L468.143 194.735L463.829 192.354C461.469 191.051 457.64 191.051 455.281 192.354L445.516 197.743C445.021 198.018 444.475 198.54 444.697 199.467C444.793 199.858 445.056 200.239 445.501 200.635C445.602 200.722 445.607 200.862 445.43 200.959C445.253 201.055 445.001 201.05 444.839 200.997C444.147 200.765 443.445 200.616 442.747 200.563C441.04 200.432 440.085 200.732 439.585 201.007L417.953 212.947C415.786 214.145 414.568 215.767 414.568 217.462V221.382C414.568 223.077 415.786 224.699 417.953 225.897L424.217 229.354C427.147 230.971 430.775 232.179 434.715 232.845C435.104 232.912 435.458 233.028 435.735 233.183L436.887 233.82C439.105 235.042 442.702 235.042 444.92 233.82L445.248 233.637C445.607 233.439 446.077 233.308 446.607 233.255C450.674 232.864 454.533 231.923 457.792 230.527L457.857 230.518C458.095 230.474 458.312 230.402 458.494 230.3L460.207 229.354L466.102 226.1C467.491 225.332 468.497 224.376 469.022 223.333C469.502 222.372 469.977 221.431 470.042 221.344Z",
    fill: "#C0D7E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.814 218.181H404.217L404 218.302V220.031L404.278 220.185H405.814C406.814 220.185 407.627 219.736 407.627 219.186C407.622 218.63 406.814 218.181 405.814 218.181Z",
    fill: "#8CAABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49 239.528C444.49 238.977 443.677 238.528 442.677 238.528C441.677 238.528 440.863 238.977 440.863 239.528V240.373L441.111 240.508H444.238L444.485 240.373V239.528H444.49Z",
    fill: "#8CAABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.079 224.043L476.64 222.628L475.14 221.803C474.432 221.412 473.286 221.412 472.578 221.803C471.871 222.194 471.871 222.826 472.578 223.217L474.079 224.043Z",
    fill: "#83A1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.126 198.366L441.626 197.54L439.064 198.955L440.565 199.781C441.272 200.172 442.419 200.172 443.126 199.781C443.833 199.39 443.833 198.757 443.126 198.366Z",
    fill: "#6D899C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.821 194.899L468.658 193.151L470.27 192.268L473.432 194.011L471.821 194.899Z",
    fill: "#6D899C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.243 247.489V240.508L500.97 209.206V216.187L444.243 247.489Z",
    fill: "#A0BED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.639 229.615L405.718 225.245V221.493L413.644 225.868V229.615H413.639ZM405.844 225.173L413.518 229.407V225.935L405.844 221.701V225.173Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 220.031V227.012L405.778 227.992V225.902L413.578 230.204V232.294L419.1 235.341V230.754L419.792 231.136V235.727L432.361 242.661V239.875L440.161 244.182V246.963L441.186 247.528V240.546L404 220.031Z",
    fill: "#A0BED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.243 240.508H441.187V247.528H444.243V240.508Z",
    fill: "#B8D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.278 220.185V227.162L404 227.012V220.031L404.278 220.185Z",
    fill: "#7390A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.778 221.6L405.814 224.729L414.379 229.389V226.479L405.778 221.6Z",
    fill: "#4B6676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.013 220.446L406.516 224.029L406.178 223.845L412.674 220.258L413.013 220.446Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.013 220.818L406.517 224.4V224.029L413.013 220.441V220.818Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.516 224.4L406.178 224.217V223.84L406.516 224.028V224.4Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.655 220.798L407.153 224.386L406.814 224.198L413.316 220.615L413.655 220.798Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.655 221.175L407.153 224.758V224.386L413.655 220.799V221.175Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.153 224.758L406.814 224.574V224.198L407.153 224.386V224.758Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.291 221.151L407.795 224.738L407.456 224.55L413.953 220.963L414.291 221.151Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.292 221.523L407.795 225.11V224.733L414.292 221.151V221.523Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.795 225.11L407.456 224.922V224.55L407.795 224.734V225.11Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.933 221.508L408.436 225.091L408.098 224.907L414.594 221.32L414.933 221.508Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.933 221.88L408.437 225.467V225.091L414.933 221.508V221.88Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.436 225.467L408.098 225.279V224.907L408.436 225.091V225.467Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.569 221.861L409.073 225.448L408.734 225.26L415.231 221.672L415.569 221.861Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.57 222.232L409.073 225.82V225.443L415.57 221.861V222.232Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.073 225.82L408.734 225.632V225.26L409.073 225.443V225.82Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.211 222.208L409.714 225.796L409.376 225.607L415.873 222.025L416.211 222.208Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.211 222.58L409.715 226.167V225.796L416.211 222.208V222.58Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.714 226.167L409.376 225.979V225.607L409.714 225.795V226.167Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.853 222.57L410.351 226.158L410.018 225.97L416.514 222.387L416.853 222.57Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.853 222.947L410.356 226.53V226.158L416.853 222.57V222.947Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.351 226.53L410.018 226.346V225.969L410.356 226.158L410.351 226.53Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.488 222.923L410.992 226.506L410.653 226.322L417.15 222.735L417.488 222.923Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.489 223.295L410.992 226.882V226.505L417.489 222.923V223.295Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.992 226.882L410.653 226.694V226.322L410.992 226.505V226.882Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.13 223.275L411.633 226.863L411.295 226.674L417.792 223.087L418.13 223.275Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.13 223.647L411.634 227.234V226.858L418.13 223.275V223.647Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.633 227.234L411.295 227.046V226.674L411.633 226.858V227.234Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.772 223.628L412.27 227.21L411.932 227.027L418.433 223.439L418.772 223.628Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.772 223.999L412.271 227.582V227.21L418.772 223.628V223.999Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27 227.582L411.932 227.399V227.022L412.27 227.21V227.582Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.408 223.98L412.912 227.563L412.573 227.379L419.07 223.792L419.408 223.98Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.409 224.352L412.912 227.939V227.563L419.409 223.98V224.352Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.912 227.939L412.573 227.751V227.379L412.912 227.563V227.939Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.222 226.77L405.552 220.879V222.502L416.222 228.505V226.77Z",
    fill: "#7390A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.55 230.653L421.585 233.202L430.072 237.905V235.337L421.55 230.653Z",
    fill: "#4B6676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.573 228.809L422.934 233.029L422.535 232.806L430.179 228.591L430.573 228.809Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.578 229.248L422.935 233.468V233.029L430.578 228.809V229.248Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.934 233.468L422.535 233.246V232.806L422.934 233.028V233.468Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.077 229.634L424.434 233.854L424.04 233.632L431.683 229.417L432.077 229.634Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.078 230.074L424.435 234.294V233.854L432.078 229.634V230.074Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.434 234.294L424.04 234.071V233.632L424.434 233.854V234.294Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.583 230.474L425.94 234.689L425.546 234.472L433.184 230.252L433.583 230.474Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.584 230.914L425.94 235.129V234.69L433.584 230.474V230.914Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94 235.129L425.546 234.912V234.472L425.94 234.689V235.129Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.089 231.305L427.446 235.52L427.047 235.303L434.69 231.083L435.089 231.305Z",
    fill: "#C7A729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.09 231.739L427.446 235.959V235.52L435.09 231.3V231.739Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.446 235.959L427.047 235.737V235.298L427.446 235.52V235.959Z",
    fill: "#A0861F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.19 234.53L421.372 229.632L421.498 231.144L430.19 235.791V234.53Z",
    fill: "#7390A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.27 193.489L471.821 194.899L472.821 194.349L470.27 192.939L469.27 193.489Z",
    fill: "#8CAABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.126 199.023L441.625 198.197L439.655 199.283L440.56 199.781C441.267 200.172 442.414 200.172 443.121 199.781C443.323 199.67 443.464 199.539 443.55 199.399C443.469 199.264 443.328 199.134 443.126 199.023Z",
    fill: "#8CAABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.578 222.527C472.396 222.628 472.26 222.744 472.174 222.87C472.26 222.995 472.396 223.111 472.578 223.212L474.078 224.038L475.983 222.986L475.139 222.522C474.432 222.141 473.285 222.141 472.578 222.527Z",
    fill: "#8CAABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.64 222.628V229.61L474.079 231.025V224.043L476.64 222.628Z",
    fill: "#B8D3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.983 222.995V229.34L476.64 229.61V222.628L475.983 222.995Z",
    fill: "#83A1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.984 229.34L474.079 230.402V231.025L476.64 229.61L475.984 229.34Z",
    fill: "#83A1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.677 238.528C441.677 238.528 440.863 238.977 440.863 239.528V240.17C440.863 239.619 441.677 239.17 442.677 239.17C443.677 239.17 444.49 239.619 444.49 240.17V239.528C444.49 238.972 443.677 238.528 442.677 238.528Z",
    fill: "#6D899C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.814 218.746C406.637 218.746 407.334 219.051 407.551 219.466C407.597 219.379 407.627 219.282 407.627 219.186C407.627 218.635 406.814 218.186 405.814 218.186H404.217L404 218.302V218.862L404.217 218.742H405.814V218.746Z",
    fill: "#6D899C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.361 239.875V242.661L434.872 241.261L432.361 239.875Z",
    fill: "#222326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.1 230.754L419.792 231.136V234.955L419.1 235.341V230.754Z",
    fill: "#4B6676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.778 225.902L407.673 226.945L405.778 227.993V225.902Z",
    fill: "#4B6676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.585 234.129V234.854L430.072 239.561V238.813L421.585 234.129Z",
    fill: "#4B6676"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M438.533 239.089L407.396 221.92L412.634 218.04L443.48 235.403L438.533 239.089Z",
    fill: "#8EACBE"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.128 294.138C302.722 295.905 298.194 294.609 293.728 291.107L281.983 296.941C286.453 300.441 290.977 301.739 294.383 299.971L306.128 294.138Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.448 269.146L309.018 271.841C312.37 282.14 311.408 291.398 306.124 294.14L294.383 299.971C299.667 297.23 300.629 287.972 297.277 277.673L291.848 280.367C292.31 276.911 291.889 255.067 291.889 255.067C291.889 255.067 306.058 261.88 314.448 269.146Z",
    fill: "url(#paint1_linear)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.417 167.982C141.119 169.327 143.771 169.092 146.625 167.626L152.521 172.121C149.665 173.586 147.015 173.822 145.313 172.477L139.417 167.982Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.472 153.217L140.198 155.294C137.236 160.653 136.779 165.896 139.42 167.983L145.314 172.477C142.674 170.389 143.13 165.147 146.092 159.787L148.818 161.864C148.932 159.896 151.502 147.814 151.502 147.814C151.502 147.814 142.907 150.08 137.472 153.217Z",
    fill: "url(#paint3_linear)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.409 157.051C408.833 159.143 406.555 160.522 403.386 161.027L401.29 168.139C404.459 167.631 406.736 166.254 407.313 164.163L409.409 157.051Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.247 143.995L401.277 147.282C406.835 149.852 410.303 153.809 409.409 157.054L407.313 164.163C408.208 160.919 404.739 156.961 399.181 154.391L398.211 157.678C396.956 156.158 387.737 147.935 387.737 147.935C387.737 147.935 396.009 144.68 402.247 143.995Z",
    fill: "url(#paint5_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 178,
    y: 445,
    width: 186,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9 0 0 0 0 0.8925 0 0 0 0 0.8925 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 295.547,
    y1: 299.654,
    x2: 291.877,
    y2: 291.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#047FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 308.458,
    y1: 294.623,
    x2: 291.245,
    y2: 251.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#047FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 144.701,
    y1: 172.176,
    x2: 147.637,
    y2: 167.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#047FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 138.072,
    y1: 168.002,
    x2: 152.19,
    y2: 146.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#047FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 407.629,
    y1: 163.559,
    x2: 402.734,
    y2: 161.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#047FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 410.507,
    y1: 156.272,
    x2: 386.209,
    y2: 147.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#047FE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375.21,
    height: 265.15,
    fill: "white",
    transform: "translate(96 174)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198.362,
    height: 168.71,
    fill: "white",
    transform: "translate(392.792 265) rotate(35.8433)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(292.557 179) rotate(18.6596)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 60.528,
    fill: "white",
    transform: "translate(404 187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 42,
    fill: "white",
    transform: "translate(268 265.791) rotate(-24.176)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1807,
    height: 23.7461,
    fill: "white",
    transform: "matrix(-0.818321 -0.574761 -0.574761 0.818321 163.617 156.323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1807,
    height: 23.7461,
    fill: "white",
    transform: "translate(383 161.962) rotate(-71.3388)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverRecycleBin);
export default __webpack_public_path__ + "static/media/recover-recycle-bin.914db36b683fd3b99acf3bf01734325c.svg";
export { ForwardRef as ReactComponent };